<template>
  <BittsTooltip class="inline" :mount-to-body="mountToBody">
    <span
      class="underline decoration-dotted decoration-[12%] underline-offset-[12%] decoration-neutral-text-weak"
      :class="textClasses ?? 'text-neutral-text'"
    >
      {{ text }}
    </span>
    <template #title>
      <p v-html="tooltipText" />
    </template>
  </BittsTooltip>
</template>

<script setup lang="ts">
import { BittsTooltip } from '@crossbeam/bitts';
const {
  text,
  textClasses,
  mountToBody = true,
} = defineProps<{
  text: string;
  textClasses?: string;
  tooltipText: string;
  mountToBody?: boolean;
}>();
</script>

<style scoped lang="pcss">
@reference "../../css/theme.css";
:deep(.bitts-tooltip-trigger) {
  @apply inline;
}
</style>
